module.exports = __webpack_public_path__ + "img/angle-left.b3fe087b.svg";